import * as React from 'react';
import {
    Button, CircularProgress,
    Grid, InputAdornment, MenuItem, TextField,
} from "@mui/material";
import {
    ArrowBackIos, ArrowForwardIos, Assignment, CalendarToday, Mail, Payment, Person,
} from "@mui/icons-material";
import Body from "../global/Body";
import reducer from "../../store/request";
import withReducer from "../../store/withReducer";
import {memo, useEffect, useState} from "react";
import {selectRequestState, setItem, setStep} from "../../store/request/stateSlice";
import {useDispatch, useSelector} from "react-redux";
import DetailService from "./components/DetailService";
import Api from "../../inc/Api";
import Alert from "../../inc/Alert";
import Toast from "../../inc/Toast";
import {selectUser} from "../../store/userSlice";

const getCardType = (number) => {
    const cardPatterns = {
        visa      : /^4[0-9]{0,15}$/,
        mastercard: /^(5[1-5][0-9]{0,14}|2[2-7][0-9]{0,14})$/,
        amex      : /^3[47][0-9]{0,13}$/,
        discover  : /^6(?:011|5[0-9]{2})[0-9]{0,12}$/,
    };

    for (const card in cardPatterns) {
        if (cardPatterns[card].test(number)) {
            return card;
        }
    }

    return '';
};

function Step5PayCard() {

    const {item} = useSelector(selectRequestState);
    const user = useSelector(selectUser);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(() => ({
        card_number      : '',
        card_type        : '',
        card_expire_year : '',
        card_expire_month: '',
        card_cvv         : '',
        card_name        : '',
    }));

    function addCard() {
        setLoading(true);
        Api.post('/client/payments/addCard', data, rsp => {
            setLoading(false);
            if (rsp.ok) {
                dispatch(setItem({id_payment: rsp.id}));
                dispatch(setStep('4'));
                Toast.success('¡Tu tarjeta ha sido guardada con éxito!');
            } else {
                Alert.error(rsp.msg);
            }
        });
    }

    return (
        <Body title="Nueva tarjeta">

            <Grid container spacing={3}>

                <Grid xs={12} md={6} item display={{xs: 'none', md: 'block'}}>

                    <DetailService/>

                </Grid>

                <Grid xs={12} md={6} item>

                    <Grid container spacing={3}>

                        <Grid xs={12} item>

                            <TextField
                                label="Número de tarjeta"
                                value={data.card_number_fmt}
                                onChange={e => {
                                    let value = e.target.value.replace(/\D/g, ''); // Eliminar todos los caracteres no numéricos
                                    if (value.length > 16) {
                                        value = value.slice(0, 16); // Limitar a 16 dígitos
                                    }
                                    const formattedValue = value.replace(/(\d{4})(?=\d)/g, '$1 '); // Formatear en grupos de 4

                                    setData({
                                        ...data,
                                        card_number    : value,
                                        card_number_fmt: formattedValue,
                                        card_type      : getCardType(value),
                                    });
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {data.card_type
                                                ? <img
                                                    src={`${process.env.PUBLIC_URL}/assets/images/cards/card_${data.card_type}.png`}
                                                    width={28}/>
                                                : <Payment color="primary"/>
                                            }
                                        </InputAdornment>
                                    ),
                                }}
                                placeholder="1234 1234 1234 1234"
                                disabled={loading}
                                autoFocus/>
                        </Grid>

                        <Grid xs={6} item>

                            <TextField
                                label="Expiración"
                                value={data.card_expire_fmt}
                                onChange={e => {
                                    let value = e.target.value.replace(/\D/g, ''); // Eliminar todos los caracteres no numéricos

                                    if (value.length < 3) {
                                        value = value.slice(0, 2) + (value.length > 2 ? '/' + value.slice(2) : '');
                                    } else {
                                        value = value.slice(0, 2) + '/' + value.slice(2, 4);
                                    }

                                    const [month, year] = value.split('/');

                                    setData({
                                        ...data,
                                        card_expire_month: month,
                                        card_expire_year : year && year.length == 2 ? `20${year}` : '',
                                        card_expire_fmt  : value,
                                    });
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <CalendarToday color="primary"/>
                                        </InputAdornment>
                                    ),
                                }}
                                placeholder="MM/AA"
                                disabled={loading}/>

                        </Grid>

                        <Grid xs={6} item>

                            <TextField
                                label="CVV"
                                value={data.card_cvv}
                                onChange={e => {
                                    let value = e.target.value.replace(/\D/g, '');
                                    setData({...data, card_cvv: value});
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Payment color="primary"/>
                                        </InputAdornment>
                                    ),
                                }}
                                disabled={loading}/>

                        </Grid>

                        <Grid xs={12} item>

                            <TextField
                                label="Nombre del titular de la tarjeta"
                                value={data.card_name}
                                onChange={e => {
                                    setData({...data, card_name: e.target.value});
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Person color="primary"/>
                                        </InputAdornment>
                                    ),
                                }}
                                disabled={loading}/>

                        </Grid>

                        <Grid xs={6} item>

                            <Button
                                variant="contained"
                                startIcon={<ArrowBackIos/>}
                                onClick={() => {
                                    dispatch(setStep('4'));
                                }}
                                color="secondary"
                                disabled={loading}
                                fullWidth>
                                Volver
                            </Button>

                        </Grid>

                        <Grid xs={6} item>

                            <Button
                                variant="contained"
                                endIcon={!loading && <ArrowForwardIos/>}
                                onClick={addCard}
                                disabled={!(data.card_number && data.card_expire_month
                                    && data.card_expire_year && data.card_cvv && data.card_name) || loading}
                                fullWidth>

                                {loading ? <CircularProgress color="inherit" size="24px"/> : 'Guardar'}

                            </Button>

                        </Grid>

                    </Grid>


                </Grid>

            </Grid>
        </Body>
    );
}

export default withReducer('request', reducer)(memo(Step5PayCard));